import { db, syncLeaderboardEntry, removeLeaderboardEntry } from './firebase';
import { collection, addDoc, getDocs, deleteDoc, doc } from 'firebase/firestore';

const FIRST = ['Ana', 'João', 'Maria', 'Pedro', 'Sofia', 'Miguel', 'Beatriz', 'Rui', 'Inês', 'Tiago',
  'Carla', 'André', 'Rita', 'Nuno', 'Marta', 'Diogo', 'Catarina', 'Bruno', 'Leonor', 'Gonçalo',
  'Mariana', 'Ricardo', 'Helena', 'Fábio', 'Daniela', 'Hugo', 'Patrícia', 'Vasco', 'Cláudia', 'Filipe'];
const LAST = ['Silva', 'Santos', 'Ferreira', 'Pereira', 'Oliveira', 'Costa', 'Rodrigues', 'Martins', 'Sousa',
  'Fernandes', 'Gonçalves', 'Lopes', 'Marques', 'Almeida', 'Ribeiro', 'Pinto', 'Carvalho', 'Teixeira', 'Moreira', 'Correia'];

const CATEGORY_IDS = ['apanhar-lixo', 'plantar-arvores', 'arte-sustentavel', 'trilhos-pe', 'trilhos-bicicleta', 'acampar'];

const rand = (n) => Math.floor(Math.random() * n);
const levelFor = (p) => (p >= 1500 ? 'Expert' : p >= 800 ? 'Avançado' : p >= 300 ? 'Intermediário' : 'Iniciante');
const slug = (s) => s.toLowerCase().normalize('NFD').replace(/[^a-z ]/g, '').trim().replace(/ +/g, '.');

// Cria N utilizadores de teste (documentos no Firestore, sem conta de login).
// Aparecem no ranking e na gestão de utilizadores. Marcados com seeded:true para poderem ser removidos.
export const seedRandomUsers = async (n = 18) => {
  let added = 0;
  for (let i = 0; i < n; i++) {
    const name = `${FIRST[rand(FIRST.length)]} ${LAST[rand(LAST.length)]}`;
    const points = rand(2001); // 0 - 2000
    // Distribuir as atividades por categorias (para testar a ordenação por tipo)
    const categoryCounts = {};
    let totalActivities = 0;
    for (const catId of CATEGORY_IDS) {
      const c = rand(9); // 0 - 8 por categoria
      if (c > 0) categoryCounts[catId] = c;
      totalActivities += c;
    }
    const userData = {
      name,
      email: `${slug(name)}${rand(99)}@exemplo.pt`,
      points,
      level: levelFor(points),
      activities: totalActivities,
      categoryCounts,
      trails: (categoryCounts['trilhos-pe'] || 0) + (categoryCounts['trilhos-bicicleta'] || 0),
      isPremium: Math.random() < 0.3,
      isAdmin: false,
      seeded: true,
      createdAt: new Date().toISOString(),
    };
    const ref = await addDoc(collection(db, 'users'), userData);
    await syncLeaderboardEntry(ref.id, userData); // aparecer no ranking
    added++;
  }
  return { added };
};

// Remove todos os utilizadores de teste (seeded:true) e as suas entradas no ranking.
export const removeSeededUsers = async () => {
  const snap = await getDocs(collection(db, 'users'));
  let removed = 0;
  for (const d of snap.docs) {
    if (d.data().seeded === true) {
      await deleteDoc(doc(db, 'users', d.id));
      try { await removeLeaderboardEntry(d.id); } catch (e) { /* entrada pode não existir */ }
      removed++;
    }
  }
  return { removed };
};
